// jumpType
// 0无跳转 1专题 2商品 3网址 4品牌团 5直播 6主播 7榜单 8店铺编码 9前台类目 10前台三级类目

/**
 * @Date: 2021-07-19 10:34:39
 * @method: 生成上报用content_type和content_id
 * @param {*} type jumpType 0无跳转 1专题 2商品 3网址 4品牌团 5直播 6主播 7榜单 8店铺编码 9前台类目 10前台三级类目
 * @param {*} value 跳转对应的值
 * @Author: 郑展羽（zhengzy1@yunjiglobal.com）
 * @LastEditTime: Do not edit
 * @LastEditors: 郑展羽（zhengzy1@yunjiglobal.com）
 */
export function createTrackObj(type, value) {
  switch (type) {
    // 专题
    case 1: return {
      content_type: '专题',
      content_id: `SUB_${value}`
    }
    // 商品
    case 2: return {
      content_type: '商品',
      content_id: `ITM_${value}` // 商品
    }
    // 网址
    case 3: return {
      content_type: '链接',
      content_id: `WEB_${value}` // 商品
    }
    // 直播
    case 5: return {
      content_type: '直播',
      content_id: `LIVE_${value}`
    }
    // 榜单
    case 7: return {
      content_type: '榜单',
      content_id: `RANK_${value}`
    }
    // 店铺
    case 8: return {
      content_type: '店铺',
      content_id: `STORE_${value}`
    }
    // 店铺
    case 9: return {
      content_type: '一级类目',
      content_id: `CATE1_${value}`
    }
    // 三级类目
    case 10: return {
      content_type: '三级类目',
      content_id: `CATE3_${value}`
    }
    default: return value
  }
}
export function createTrackContentIdList(arr) {
  const contentIdList = []
  arr.forEach((item) => {
    const temp = createTrackObj(item.jumpType, item.jumpValue)
    if (temp.content_id) contentIdList.push(temp.content_id)
  })
  return contentIdList.join(',')
}

/**
 * @Date: 2021-07-19 11:33:57
 * @method: app跳转
 * @param {*} data { jumpType, jumpValue }
 * @Author: 郑展羽（zhengzy1@yunjiglobal.com）
 * @LastEditTime: Do not edit
 * @LastEditors: 郑展羽（zhengzy1@yunjiglobal.com）
 */
function jumpInApp(data) {
  const { jumpType, jumpValue } = data
  switch (jumpType) {
    // 专题
    case 1:
      window.location.href = `yunji://common/gotoSubject?subjectId=${jumpValue}`
      break
    // 商详
    case 2:
      window.location.href = `yunji://common/itemDetail?itemId=${jumpValue}`
      break
    // 链接
    case 3:
      window.location.href = `yunji://gotoExternalLink?url=${jumpValue}`
      break
    // 直播
    case 5:
      window.location.href = `yunji://common/golive?consumerId=${jumpValue}&liveId=${jumpValue}`
      break
    // 榜单
    case 7:
      window.location.href = `yunji://gotoExternalLink?url=${encodeURIComponent(jumpValue)}`
      break
    // 店铺
    case 8:
      window.location.href = `yunji://common/goPopShopHome?storeCode=${jumpValue}`
      break
    // 一级类目
    case 9:
      window.location.href = `yunji://common/gotoOldCategory?categoryId=${jumpValue}&isRNPage=1`
      break
    // 三级类目
    case 10:
      window.location.href = `yunji://common/goNewGoodsGategory?categoryId=${data.categoryId}&categoryLevelId=${jumpValue}&categoryName=${encodeURIComponent(data.imageTitle)}`
      break
    default: break
  }
}

/**
 * @Date: 2021-07-19 11:33:57
 * @method: H5跳转
 * @param {*} data { jumpType, jumpValue }
 * @Author: 郑展羽（zhengzy1@yunjiglobal.com）
 * @LastEditTime: Do not edit
 * @LastEditors: 郑展羽（zhengzy1@yunjiglobal.com）
 */
function jumpH5(data) {
  const { 
    jumpType, 
    jumpValue, 
    appCont, 
    shopId 
  } = data
  switch (jumpType) {
    // 专题
    case 1:
      window.location.href = `${window.location.origin}${globalConfig.staticSubjectBasePath}?subjectId=${jumpValue}&appCont=${appCont}&shopId=${shopId}`
      break
    // 商详
    case 2:
      window.location.href = `${window.location.origin}/yjbuyer/detail?itemId=${jumpValue}&appCont=${appCont}&shopId=${shopId}`
      break
    // 链接
    case 3:
      window.location.href = jumpValue
      break
    // 榜单
    case 7:
      window.location.href = jumpValue
      break
    // 店铺
    case 8:
      window.location.href = `${window.location.origin}/yjbuyer/shop?storeCode=${jumpValue}&appCont=${appCont}&shopId=${shopId}`
      break
    // 一级类目
    default: break
  }
}


/**
 * @Date: 2021-07-19 11:33:57
 * @method: 小程序
 * @param {*} data { jumpType, jumpValue }
 * @Author: 郑展羽（zhengzy1@yunjiglobal.com）
 * @LastEditTime: Do not edit
 * @LastEditors: 郑展羽（zhengzy1@yunjiglobal.com）
 */
function jumpWechatMini(data) {
  const { 
    jumpType, 
    jumpValue,
    shopId 
  } = data
  switch (jumpType) {
    // 专题
    case 1:
      wx.miniProgram.navigateTo({ url: `/pages/subject/subject?subjectId=${jumpValue}` })
      break
    // 商详
    case 2:
      wx.miniProgram.navigateTo({  
        url: `/pages/detail/detail?itemId=${jumpValue}&shopId=${shopId}&yunjiweidian=1&isPreview=0`
      })
      break
    default: break
  }
}

/**
 * app分享到微信
 * @param {*} url 
 * @param {*} shareTitle 
 * @param {*} shareText 
 * @param {*} shareImg 
 */
export function shareWxInApp(url, shareTitle, shareText, shareImg) {
  const shareUrl = `${url}`
  const H5AppHref = `yunji://doubleTwelve/share?link=${encodeURIComponent(shareUrl)}&imgUrl=${encodeURIComponent(shareImg)}&title=${encodeURIComponent(shareTitle)}&content=${encodeURIComponent(shareText)}`
  console.log('app H5 分享', H5AppHref)
  window.location.href = H5AppHref
}

/**
 * @Date: 2021-07-19 10:30:58
 * @method: 公共跳转方法
 * @param {*} data 跳转数据
 * @param {*} type 0h5 1或者2客户端 7小程序
 * @Author: 郑展羽（zhengzy1@yunjiglobal.com）
 * @LastEditTime: Do not edit
 * @LastEditors: 郑展羽（zhengzy1@yunjiglobal.com）
 */
export function jumpHandle(data, type) {
  type = parseInt(type || 0, 10)
  if (type === 1 || type === 2) {
    jumpInApp(data)
  } else if (type == 0) {
    jumpH5(data)
  } else if (type == 7) {
    jumpWechatMini(data)
  }
}
